import { PATHS } from './paths';
import { RESOURCES } from 'src/utils/permissions';
import type { ResourcePathAllowing } from 'src/utils/permissions';

export const ROUTE_PERMISSIONS: Record<string, ResourcePathAllowing<'get'>> = {
  [PATHS.app.dashboard]: RESOURCES.COURSE.MAIN,
  [PATHS.app.courses]: RESOURCES.COURSE.MAIN,
  [PATHS.app.singleCourse]: RESOURCES.COURSE.MAIN,
  [PATHS.app.survey]: RESOURCES.SURVEY.MAIN,
  [PATHS.app.lecture]: RESOURCES.LECTURE.CONTENT,
  [PATHS.app.exam]: RESOURCES.EXAM.QUESTIONS,
  [PATHS.app.examCreate]: RESOURCES.EXAM.QUESTIONS,
  [PATHS.app.examCreateFromFileStep]: RESOURCES.EXAM.QUESTIONS,
  [PATHS.app.examCreateFromLecturesStep]: RESOURCES.EXAM.CREATE_FROM_LECTURES,
  [PATHS.app.feedbacks]: RESOURCES.FEEDBACK.MAIN,
  [PATHS.app.categories]: RESOURCES.CATEGORY.MAIN,
  [PATHS.app.students]: RESOURCES.STUDENT.MAIN,
  [PATHS.app.studentsImport]: RESOURCES.STUDENT.IMPORT,
  [PATHS.app.singleStudent]: RESOURCES.STUDENT.PROFILE,
  [PATHS.app.orgStructure]: RESOURCES.ORG_STRUCTURE.UNITS,
  [PATHS.app.assignments]: RESOURCES.ASSIGNMENT.MAIN,
  [PATHS.app.singleAssignment]: RESOURCES.ASSIGNMENT.MAIN,
  [PATHS.app.submissions]: RESOURCES.SUBMISSION.MAIN,
  [PATHS.app.singleStream]: RESOURCES.STREAM.MAIN,
  [PATHS.app.singleGroup]: RESOURCES.GROUP.MAIN,
  [PATHS.app.members]: RESOURCES.MEMBER.MAIN,
  [PATHS.app.singleMember]: RESOURCES.MEMBER.PROFILE,
  [PATHS.app.examSubmissions]: RESOURCES.EXAM_SUBMISSION.MAIN,
  [PATHS.app.singleExamSubmission]: RESOURCES.EXAM_SUBMISSION.MAIN,
  [PATHS.app.practiceResults]: RESOURCES.EXAM_SUBMISSION.PRACTICE,
  [PATHS.app.singlePracticeResult]: RESOURCES.EXAM_SUBMISSION.PRACTICE,
  [PATHS.app.courseCollections]: RESOURCES.COURSE_COLLECTION.MAIN,
  [PATHS.app.singleCourseCollection]: RESOURCES.COURSE_COLLECTION.MAIN,
  [PATHS.app.analytics]: RESOURCES.ANALYTICS.MAIN,
  [PATHS.app.analyticsProgress]: RESOURCES.ANALYTICS.PROGRESS,
  [PATHS.app.analyticsProgressByMembers]: RESOURCES.ANALYTICS.MEMBERS,
  [PATHS.app.analyticsProgressByContent]: RESOURCES.ANALYTICS.CONTENT,
  [PATHS.app.analyticsPoints]: RESOURCES.ANALYTICS.POINTS,
  [PATHS.app.analyticsTrainingControl]: RESOURCES.ANALYTICS.TRAINING_CONTROL,
  [PATHS.app.profileSettings]: RESOURCES.PROFILE_SETTINGS.MAIN,
  [PATHS.app.platformSettings]: RESOURCES.PLATFORM_SETTINGS.MAIN,
  [PATHS.app.platformBilling]: RESOURCES.SUBSCRIPTION.MAIN,
  [PATHS.app.tariffs]: RESOURCES.COURSE.TARIFFS,
  [PATHS.app.auditLogs]: RESOURCES.AUDIT_LOG.MAIN,
  [PATHS.app.paymentMethods]: RESOURCES.PAYMENT.MAIN,
  [PATHS.app.salesHistory]: RESOURCES.SALES_HISTORY.MAIN,
  [PATHS.app.chatbot]: RESOURCES.CHATBOT.MAIN,
  [PATHS.app.chats]: RESOURCES.CHAT.MAIN,
  [PATHS.app.singleChat]: RESOURCES.CHAT.MAIN,
  [PATHS.app.liveSessions]: RESOURCES.LIVE_SESSION.MAIN,
  [PATHS.app.liveSessionReport]: RESOURCES.LIVE_SESSION.ATTENDANCE,
  [PATHS.app.liveSessionCall]: RESOURCES.LIVE_SESSION.MAIN,
  [PATHS.app.integrations]: RESOURCES.INTEGRATION.MAIN,
  [PATHS.app.singleIntegration]: RESOURCES.INTEGRATION.MAIN,
  [PATHS.app.aiAgents]: RESOURCES.INTEGRATION.MAIN,
};

export const getResourceForPath = (path: string): ResourcePathAllowing<'get'> | null => {
  if (path.startsWith('/courses/') && path.includes('/lecture/')) {
    return RESOURCES.LECTURE.CONTENT;
  }
  if (path.startsWith('/courses/') && path.includes('/exam/')) {
    return RESOURCES.EXAM.QUESTIONS;
  }
  if (path.startsWith('/courses/') && path.includes('/survey/')) {
    return RESOURCES.SURVEY.MAIN;
  }
  if (path.startsWith('/courses/') && path !== '/courses') {
    return RESOURCES.COURSE.MAIN;
  }
  if (path === PATHS.app.studentsImport) {
    return RESOURCES.STUDENT.IMPORT;
  }
  if (path.startsWith('/students/') && path !== '/students') {
    return RESOURCES.STUDENT.PROFILE;
  }
  if (path.startsWith('/assignments/')) {
    return RESOURCES.ASSIGNMENT.MAIN;
  }
  if (path.startsWith('/submissions/')) {
    return RESOURCES.SUBMISSION.MAIN;
  }
  if (path.startsWith('/exam-submissions/')) {
    return RESOURCES.EXAM_SUBMISSION.MAIN;
  }
  if (path.startsWith('/practice-results/')) {
    return RESOURCES.EXAM_SUBMISSION.PRACTICE;
  }
  if (path.startsWith('/course-collections/')) {
    return RESOURCES.COURSE_COLLECTION.MAIN;
  }
  if (path.startsWith('/streams/')) {
    return RESOURCES.STREAM.MAIN;
  }
  if (path.startsWith('/groups/')) {
    return RESOURCES.GROUP.MAIN;
  }
  if (path.startsWith('/members/') && path !== '/members') {
    return RESOURCES.MEMBER.PROFILE;
  }
  if (path.startsWith('/chats/')) {
    return RESOURCES.CHAT.MAIN;
  }
  if (path.startsWith('/live-sessions/') && path !== '/live-sessions/') {
    return path.endsWith('/call') ? RESOURCES.LIVE_SESSION.MAIN : RESOURCES.LIVE_SESSION.ATTENDANCE;
  }
  if (path.startsWith('/integrations/')) {
    return RESOURCES.INTEGRATION.MAIN;
  }

  return ROUTE_PERMISSIONS[path] || null;
};
